import { CreateButton } from "@/components/admin";
import { useHasPermission } from "../../rbac/useHasPermission";

interface PermissionCreateButtonProps {
  permission: string;
  label?: string;
}

export const PermissionCreateButton = ({
  permission,
  label,
}: PermissionCreateButtonProps) => {
  const { hasPermission, isLoading } = useHasPermission(permission);

  if (isLoading || !hasPermission) return null;

  return <CreateButton label={label} />;
};
